import { render } from "./AdminArgenIframe.vue?vue&type=template&id=09f3de92&ts=true"
import script from "./AdminArgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./AdminArgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__